export const DEFAULT_TRIAL_PERIOD = 14;